//
//
//
//
//
//
//
//
//
//
//
//
//

import TextPolicyData from '~/components/PolicyData/TextPolicyData'
import ModalWithTitleBar from '~/components/Shared/ModalWithTitleBar.vue'
export default {
  name: 'ModalPolicyData',
  components: { TextPolicyData, ModalWithTitleBar },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleModal() {
      this.$emit('toggle')
    },
  },
}
